import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PostPutPresignedUrlArrayDto } from "../types/api/api-types";
import { axiosApi } from "./axios";

const postS3UploadUrlArrayCustomCotation = async (payload: PostPutPresignedUrlArrayDto) => {
  return axiosApi.post<any>("/s3/urlsWoCotation", payload);
};

export const usePostS3UploadUrlArrayCustomCotation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postS3UploadUrlArrayCustomCotation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["customCotations"],
      });
    },
    onError: () => {},
  });
};

export const getFile = async (key: string, filename?: string) => {
  return axiosApi
    .get<string>("/s3/get-file", { params: { key, ...(filename ? { filename } : {}) } })
    .then((res) => res.data);
};

export const useMutateGetFile = () => {
  return useMutation({
    mutationFn: getFile,
    onSuccess: () => {},
    onError: () => {},
  });
};
